<template>
  <div class="c-track-plan g-container">
    <div class="module-content" ref="container">
      <moduler name="trackplanadd" :title="title">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field item-must">计划名称</span>
          </Col>
          <Col span="12">
            <input-len v-model="formItem.planName" placeholder="最大120个字符，1个中文等于2个字符" :max="120" width="392" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放平台</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="formItem.platform" type="button" @on-change="platformChange">
              <Radio :label="1">Android</Radio>
              <Radio :label="2">iOS</Radio>
              <Radio :label="3">小程序</Radio>
              <Radio :label="5">鸿蒙</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field item-must">投放应用</span>
          </Col>
          <Col span="12">
            <el-select
              v-model="formItem.gameId"
              filterable
              size="small"
              style="width: 240px; margin-right: 12px"
              placeholder="请选择投放应用"
              @change="changeGame"
            >
              <el-option v-for="item in appDataByPlatform" :key="item.id" :value="item.id" :label="item.name" style="width: 240px">
              </el-option>
            </el-select>
            <el-button v-if="permissions.includes('M21065')" type="text" size="small" @click="showCommonlyGameConfigModal = true"
              >常用应用管理</el-button
            >
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field item-must">投放媒体</span>
          </Col>
          <Col span="12">
            <el-select
              v-model="formItem.mediaId"
              filterable
              size="small"
              style="width: 240px"
              placeholder="请选择投放媒体"
              @change="changeMedia"
            >
              <el-option v-for="item in mediaList" :key="item.id" :value="item.id" :label="item.name" style="width: 240px"> </el-option>
            </el-select>
          </Col>
        </Row>

        <Row v-if="subMediaOptions.length" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">子媒体版本</span>
          </Col>
          <Col span="12">
            <el-select v-model="formItem.subMediaId" size="small" style="width: 240px" placeholder="请选择子媒体版本">
              <el-option v-for="item in subMediaOptions" :key="item.id" :value="item.id" :label="item.name" style="width: 240px">
              </el-option>
            </el-select>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="formItem.mediaId === 214">
          <Col span="3" class="col-item">
            <span class="item-field item-must">监测链接</span>
          </Col>
          <Col span="12">
            <el-radio-group v-model="formItem.monitorType">
              <el-radio :label="1">监测链接</el-radio>
              <el-radio :disabled="[2, 3, 5].includes(formItem.platform)" :label="2">智能分包</el-radio>
            </el-radio-group>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="showCreatePkgLink">
          <Col span="3" class="col-item">
            <span class="item-field item-must">创建分包链接</span>
          </Col>
          <Col span="12">
            <i-Switch v-model="formItem.simplePlanFlag" :true-value="0" :false-value="1" />
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field item-must">投放位</span>
          </Col>
          <Col span="12">
            <el-select
              v-model="formItem.advertPosiId"
              collapse-tags
              filterable
              clearable
              multiple
              :multiple-limit="10"
              size="small"
              style="width: 240px"
              placeholder="请选择投放位"
            >
              <el-option v-for="item in advPositionDataByMedia" :key="item.id" :value="item.id" :label="item.name" style="width: 240px">
              </el-option>
            </el-select>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field item-must">媒体账号</span>
          </Col>
          <Col span="12">
            <el-select v-model="formItem.adAccountId" filterable size="small" style="width: 240px" placeholder="请选择媒体账号">
              <el-option v-for="item in accountDataByMedia" :key="item.id" :value="item.id" :label="item.name" style="width: 240px">
              </el-option>
            </el-select>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">API数据回调</span>
          </Col>
          <Col span="12">
            <i-Switch v-model="formItem.callbackSwitch" :disabled="formItem.platform === 2" :true-value="1" :false-value="0" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-show="formItem.callbackSwitch === 1 && callbackTypes.length">
          <Col span="3" class="col-item">
            <span class="item-field"></span>
          </Col>
          <Col span="12">
            <CheckboxGroup v-model="formItem.callbackSettings">
              <Checkbox label="callbackTypeActive" v-if="callbackTypes.includes(1)" disabled>激活</Checkbox>
              <Checkbox label="callbackTypeRegist" v-if="callbackTypes.includes(2)">注册</Checkbox>
              <Checkbox label="callbackTypeOrder" v-if="callbackTypes.includes(3)">下单</Checkbox>
              <Checkbox label="callbackTypeRecharge" v-if="callbackTypes.includes(4)">付费</Checkbox>
              <Checkbox label="callbackTypeMoney" v-if="callbackTypes.includes(5)">订单金额</Checkbox>
              <Checkbox label="callbackTypeRole" v-if="callbackTypes.includes(6)">创角</Checkbox>
              <Checkbox label="callbackTypeRetain" v-if="callbackTypes.includes(7)">留存</Checkbox>
              <Checkbox label="callbackTypeKeyBehavior" v-if="callbackTypes.includes(8)">关键行为</Checkbox>
            </CheckboxGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="formItem.launchType" type="button" @on-change="formItem.pageId = ''">
              <Radio :label="1">直接下载</Radio>
              <Radio :label="2">进入落地页</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="formItem.platform === 2">
          <Col span="3" class="col-item">
            <span class="item-field item-must">苹果商店地址</span>
          </Col>
          <Col span="12">
            <span>{{ formItem.gamePackAddr || '——————' }}</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="formItem.launchType === 2">
          <Col span="3" class="col-item">
            <span class="item-field">落地页ID</span>
          </Col>
          <Col span="12">
            <Button type="primary" @click="pickPageModal = true">选择落地页</Button>
            <span style="margin-left: 12px">{{ formItem.pageId }}</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="permissions.includes('M21066')">
          <Col span="3" class="col-item">
            <span class="item-field">官方渠道包</span>
          </Col>
          <Col span="12">
            <i-Switch v-model="formItem.officialChannelFlag" />
            <span style="margin-left: 12px; color: #ff6400">此功能仅适用于新建安卓官方自然量计划,其他情况请勿开启！</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="formItem.officialChannelFlag">
          <Col span="3" class="col-item">
            <span class="item-field"></span>
          </Col>
          <Col span="12">
            <CheckboxGroup v-model="formItem.officialChannelSetting">
              <Checkbox label="buy">买量自然量渠道</Checkbox>
              <Checkbox label="SDK">草花SDK渠道</Checkbox>
              <Checkbox label="APP">草花APP渠道</Checkbox>
              <Checkbox label="WAP">草花WAP渠道</Checkbox>
              <Checkbox label="PC">草花PC渠道</Checkbox>
            </CheckboxGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">批量建计划序号</span>
          </Col>
          <Col span="12">
            <input-range v-model="range" :min="1" :max="999" :step="100" />
            <p style="color: #ff6400; margin-top: 8px; position: absolute">
              非必填项, 数值差异不超过100(计划数太多页面可能会卡顿卡死，实际建计划还是会成功)
            </p>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">外投授权</span>
          </Col>
          <Col span="12">
            <i-Switch v-model="isProxyAuth" @on-change="formItem.proxyAccountId = ''" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="isProxyAuth">
          <Col span="3" class="col-item">
            <span class="item-field"></span>
          </Col>
          <Col span="12">
            <el-select v-model="formItem.proxyAccountId" filterable size="small" style="width: 240px" placeholder="请选择代投账号">
              <el-option v-for="item in agentList" :key="item.id" :value="item.id" :label="item.name" style="width: 240px"> </el-option>
            </el-select>
          </Col>
        </Row>
      </moduler>
    </div>
    <!-- 常用应用管理 -->

    <CommonlyGameConfigModal :visible.sync="showCommonlyGameConfigModal">
      <el-button @click="onCommonlyGamesConfigModalClose">取 消</el-button>
      <el-button type="primary" :loading="commonlyGamesConfigSubmitLoading" @click="onCommonlyGamesConfigConfirm">确 定</el-button>
    </CommonlyGameConfigModal>

    <!-- 选择落地页列表 -->
    <land-page v-model="pickPageModal" :defaultGameId="formItem.gameId" @on-select="pickPageSelect" />
    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" :loading="loading" @click.stop="submit()">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import store from '@/store'
import { HOST_API } from '@/api/config'
import { isEmpty, isArray, getByteLen } from '@/common/js/utils'
import { getCaoHuaGames, adGames } from '@/api/common.model'
import { getTrackPlan, createTrackPlan, createTrackPlanResultExport } from '@/api/track.plan.model'
import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'
import InputRange from '@/components/input/input-number-range'
import LandPage from '@/components/landpage/landpage'
import CommonlyGameConfigModal from './components/commonly-games-config/index.vue'

import { useCommonlyGameConfig } from './hooks/useTable.js'
import { mediaCallbackSettingsInfo, callbackKeys } from './consts/index.js'
import { initPageData, MEDIAS, MEDIA_POSITION, MEDIA_ACCOUNTS, AGENTS } from '@/data/global-opts'

import { Modal } from 'view-design'

const route = useRoute()
const router = useRouter()

const PAGE_REQUIRED_OPTS = initPageData([MEDIAS, MEDIA_POSITION, MEDIA_ACCOUNTS, AGENTS])
// 2002头条 2003腾讯广告 2005快手 2008百度oCPC  2004阿里汇川(UC)
const sdkMedias = [2002, 2003, 2005, 2008, 2004]
// 创建分包链接的媒体 10头条 16腾讯广告 32快手 191巨量星图 215星广联投（星图） 216星广联投（AD版）
const createPkgLinkMediaIds = [10, 16, 32, 191, 215, 216]
const subMediaOptionsByMedia = {
  10: [
    { id: 1, name: '普通/默认' },
    { id: 2, name: '头条2.0' },
    { id: 3, name: '智擎3.0' }
  ],
  16: [
    { id: 1, name: '普通/默认' },
    { id: 2, name: '腾讯2.0' },
    { id: 3, name: '腾讯3.0' }
  ]
}

const mediaList = computed(PAGE_REQUIRED_OPTS.MEDIAS)
const mediaPositionList = computed(PAGE_REQUIRED_OPTS.MEDIA_POSITION)
const mediaAccountList = computed(PAGE_REQUIRED_OPTS.MEDIA_ACCOUNTS)
const agentList = computed(PAGE_REQUIRED_OPTS.AGENTS)

// 响应式状态
const planId = ref(route.query.id)
const formItem = reactive({
  planName: '',
  platform: 1,
  gameId: '',
  mediaId: '',
  subMediaId: '',
  simplePlanFlag: 0,
  advertPosiId: [],
  adAccountId: '',
  monitorType: 1,
  callbackSwitch: 1,
  callbackSettings: ['callbackTypeActive'],
  launchType: 1,
  gamePackAddr: '',
  pageId: '',
  officialChannelFlag: false,
  officialChannelSetting: ['buy', 'SDK', 'APP', 'WAP', 'PC'],
  bitchAddBegin: '',
  bitchAddEnd: '',
  proxyAccountId: '',
  callType: 1
})

const allAppData = ref([])
const appData = ref([])
const range = ref([])
const pickPageModal = ref(false)
const isProxyAuth = ref(false)
const loading = ref(false)
const formErr = ref(false)
const errRes = ref([])

// 计算属性
const isCopy = computed(() => route.query.t === 'copy')
const title = computed(() => (isCopy.value ? '复制追踪计划' : '创建追踪计划'))
const callbackTypes = computed(() => {
  const arr = mediaCallbackSettingsInfo.get(String(formItem.mediaId))
  return arr || []
})
const appDataByPlatform = computed(() => {
  return appData.value.filter((ret) => ret.platform === formItem.platform)
})
const advPositionDataByMedia = computed(() => {
  return mediaPositionList.value.filter((ret) => ret.mediaId === formItem.mediaId)
})
const accountDataByMedia = computed(() => {
  return mediaAccountList.value.filter((ret) => ret.mediaId === formItem.mediaId)
})
const subMediaOptions = computed(() => subMediaOptionsByMedia[formItem.mediaId] || [])
const permissions = computed(() => store.state.accessAuth)
const showCreatePkgLink = computed(() => {
  return formItem.platform === 1 && createPkgLinkMediaIds.includes(formItem.mediaId)
})

// 监听器
watch(range, (nVal) => {
  if (nVal.length > 1) {
    formItem.bitchAddBegin = nVal[0]
    formItem.bitchAddEnd = nVal[1]
  }
})

const { showCommonlyGameConfigModal, commonlyGamesConfigSubmitLoading, onCommonlyGamesConfigModalClose, onCommonlyGamesConfigConfirm } =
  useCommonlyGameConfig()

// 方法
const getData = () => {
  getTrackPlan({
    planId: planId.value
  }).then((data) => {
    if (data) {
      const {
        planName,
        platform,
        gameId,
        gamePackAddr,
        mediaId,
        subMediaId,
        advertPosiId,
        adAccountId,
        callbackSwitch,
        callbackSettings,
        launchType,
        pageId,
        proxyAccountId,
        monitorType
      } = data
      formItem.planName = `${planName}_复制`
      formItem.platform = platform
      formItem.gameId = gameId
      formItem.mediaId = mediaId
      formItem.subMediaId = subMediaOptionsByMedia[mediaId] ? subMediaId || 1 : ''
      formItem.advertPosiId = isEmpty(advertPosiId) ? [] : advertPosiId.split(',').map((ret) => Number(ret))
      formItem.adAccountId = adAccountId
      formItem.callbackSwitch = callbackSwitch || 0
      formItem.monitorType = monitorType || 1
      if (!isEmpty(callbackSettings)) {
        const arr = []
        const setting = JSON.parse(callbackSettings)
        for (const key of Object.keys(setting)) {
          if (setting[key] === 1) arr.push(key)
        }
        formItem.callbackSettings = arr
      }
      formItem.launchType = launchType
      formItem.pageId = pageId
      if (!isEmpty(proxyAccountId)) {
        isProxyAuth.value = true
        formItem.proxyAccountId = proxyAccountId
      }
      if (platform === 2) formItem.gamePackAddr = gamePackAddr
      if (platform === 3) {
        // 复制时，为小程序加上gamePackAddr提交参数
        changeGame(gameId)
      }
    }
    changeCallbackSwitch(true)
  })
}

const platformChange = () => {
  formItem.gameId = ''
  formItem.gamePackAddr = ''
  if (formItem.platform === 2) {
    formItem.callbackSwitch = 1
  }
  if (formItem.mediaId === 214) {
    if (formItem.platform !== 1) {
      formItem.monitorType = 1
    }
  }
}

const initApiCallbackState = () => {
  const { sdks } = appDataByPlatform.value.find((ret) => ret.id === formItem.gameId)
  const { platform } = formItem

  // 只处理sdkMedias内包含的媒体；其他的默认开启
  if (platform === 1) {
    // 【API数据回调】对于接了媒体SDK参数的安卓包体，默认回调开关是关闭的；没有对接媒体参数的，默认开启；
    if (sdkMedias.some((id) => sdks.includes(String(id)))) {
      formItem.callbackSwitch = 0
    } else {
      formItem.callbackSwitch = 1
    }
  } else {
    // IOS和小程序，API默认开启
    formItem.callbackSwitch = 1
  }
}

const changeGame = (gameId) => {
  const { gamePackAddr } = appDataByPlatform.value.find((ret) => ret.id === gameId)
  formItem.gamePackAddr = gamePackAddr
  initApiCallbackState()
}

const changeCallbackSwitch = (val) => {
  if (val) {
    const types = []
    for (const key of callbackTypes.value) {
      types.push(callbackKeys[key - 1])
    }
    formItem.callbackSettings = types
  }
}

const changeMedia = () => {
  formItem.subMediaId = subMediaOptions.value.length ? 1 : ''
  formItem.advertPosiId = []
  formItem.adAccountId = ''
  changeCallbackSwitch(true)
}

const pickPageSelect = (page) => {
  const { land_page_id } = page
  formItem.pageId = land_page_id
  pickPageModal.value = false
}

const submit = () => {
  errRes.value = [...validPrams()]
  if (errRes.value.length) {
    formErr.value = true
    return
  }
  const params = JSON.parse(JSON.stringify(formItem))
  for (const key of Object.keys(params)) {
    if (params[key] === '') delete params[key]
  }

  // 只有安卓需要传创建分包链接，或在包含的媒体中的媒体需要传创建分包链接
  if (params.platform !== 1 || !showCreatePkgLink.value) {
    delete params.simplePlanFlag
  }

  // 只有华为应用商店需要传参
  if (params.mediaId !== 214) {
    delete params.monitorType
  }

  // 只有头条和腾讯存在子媒体版本
  if (!subMediaOptions.value.length) {
    delete params.subMediaId
  }

  // 广告位多选单独处理
  params.advertPosiId = params.advertPosiId.join(',')
  // 单独处理数据回调设置
  params.callbackSettings = getCallbackSettings()
  // 官方配置单独处理
  if (formItem.officialChannelFlag) params.officialChannelSetting = JSON.stringify(formItem.officialChannelSetting)
  else delete params.officialChannelSetting

  loading.value = true
  createTrackPlan(params).then((data) => {
    loading.value = false
    if (!data) return
    const { listData } = data
    const successTotal = isArray(listData) ? listData.filter((ret) => ret.status === '新建成功').length : 0
    const failTotal = isArray(listData) ? listData.length - successTotal : 0
    if (typeof successTotal === 'number' || typeof failTotal === 'number') {
      const url = `${HOST_API}/api/ptom/tracePlan/downLoadResult?resultList=`
      Modal.info({
        title: '新建结果',
        content: `成功${successTotal}条，失败${failTotal}条`,
        okText: '下载新建计划结果',
        closable: true,
        onOk: () => {
          createTrackPlanResultExport({ resultList: listData }).then((data) => {
            if (data) cannel()
          })
        }
      })
    }
  })
}

const validPrams = () => {
  const err = []
  const {
    planName,
    gameId,
    platform,
    mediaId,
    advertPosiId,
    adAccountId,
    proxyAccountId,
    launchType,
    pageId,
    bitchAddBegin,
    bitchAddEnd,
    gamePackAddr
  } = formItem

  if (isEmpty(planName)) err.push({ feild: '计划名称', msg: '计划名称不能为空！' })
  else if (getByteLen(planName) > 120) err.push({ feild: '计划名称', msg: '计划名称最多120个字符！' })
  // 检验不可为空项
  if (isEmpty(gameId)) err.push({ feild: '投放应用', msg: '投放应用不能为空！' })
  if (isEmpty(mediaId)) err.push({ feild: '投放媒体', msg: '投放媒体不能为空！' })
  if (isArray(advertPosiId) && !advertPosiId.length) err.push({ feild: '投放位', msg: '投放位不能为空！' })
  if (isEmpty(adAccountId)) err.push({ feild: '投放账号', msg: '投放账号不能为空！' })
  if (isProxyAuth.value && isEmpty(proxyAccountId)) err.push({ feild: '代投账号', msg: '外头授权开启，代投账号不能为空！' })
  if (launchType === 2 && isEmpty(pageId)) err.push({ feild: '落地页', msg: '投放方式为进入落地页，落地页不能为空！' })
  if (isEmpty(bitchAddBegin) && !isEmpty(bitchAddEnd)) err.push({ feild: '批量建计划序号', msg: '批量建计划起始值不可为空！' })
  if (!isEmpty(bitchAddBegin) && isEmpty(bitchAddEnd)) err.push({ feild: '批量建计划序号', msg: '批量建计划结束值不可为空！' })
  if (platform === 2 && isEmpty(gamePackAddr)) {
    err.push({ feild: '苹果商店地址', msg: '苹果商店地址不可为空，请到常用应用管理调整配置！' })
  }
  return err
}

const preload = () => {
  return Promise.all([adGames({ type: 2 }), getCaoHuaGames()]).then((data) => {
    const [allAppData_, appData_] = data
    if (isArray(appData_)) {
      appData.value = appData_.map((ret) => {
        return {
          ...ret,
          platform: ret.ch_platform_id,
          gamePackAddr: ret.game_address
        }
      })
    }
    isArray(allAppData_) && (allAppData.value = allAppData_)
  })
}

const getCallbackSettings = () => {
  const { callbackSwitch, callbackSettings } = formItem
  const updateSetting = {}
  if (callbackSwitch) {
    for (const key of callbackKeys) {
      if (callbackSettings.includes(key)) updateSetting[key] = 1
      else updateSetting[key] = 0
    }
  }
  return JSON.stringify(updateSetting)
}

const cannel = () => {
  router.push({ name: 'trackplanlist' })
}

// 生命周期钩子
onMounted(() => {
  preload().then(() => {
    if (isCopy.value) getData()
  })
})
</script>

<style lang="scss" scoped>
.c-track-plan {
  .module-content {
    overflow-y: auto;
    height: calc(100vh - 260px);
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

::v-deep .el-input input {
  padding: 0 8px;
}

::v-deep .el-select__input {
  margin-left: 8px;
}
</style>
